import { Route } from "vue-router";
import { ExtendedRouteConfig } from "./ExtendedRouteConfig";
import { Query } from "./Query";
import { Dispatcher } from "./Dispatcher";

export abstract class AbstractRoutesFactory<TQuery extends Query, TDispatcher extends Dispatcher<TQuery>> {
  constructor(protected readonly _dispatcher: TDispatcher) {
  }

  abstract create(): ExtendedRouteConfig[];

  protected toProps(source: Route, create: (q: TQuery, r?: Route) => any): any {
    return create(this.toQuery(source), source);
  }

  protected toQuery(source: Route): TQuery {
    return this._dispatcher.toQuery(source);
  }
}
